import { CommonModule } from '@angular/common';
import { Component, HostBinding, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.css'],
    standalone: true,
    imports:[CommonModule,RouterModule]
})
export class FooterComponent implements OnInit {
  @HostBinding('class') classes = 'footer-container';
  constructor() { }

  ngOnInit(): void {
  }

}
